import * as React from 'react';
import classNames from 'classnames';
import './Title.scss';

interface IProps {
  children: any;
  size?: 'default' | 'small';
  color?: 'light';
  className?: string
}

const Title = (props: IProps) => {
  const classes = [
    'title',
    props.size && props.size !== 'default' && `is-${props.size}`,
    props.color && `is-${props.color}`,
    props.className
  ];

  return (
    <div className={classNames(classes)}>{props.children}</div>
  );
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title/index.tsx